/**
* @file 系统设置-轮播广告-新增/编辑广告
* */
<template>
  <div id="couponForm">
    <el-dialog :visible.sync="lineVisible" :close-on-click-modal="false" :close-on-press-escape="false" width="40%"
      :title="'【' + lineForm.params.organizationName + '】的线路'">
      <div>
        <div>
          <el-input style="width: 150px" v-model="lineForm.params.startStationName" placeholder="出发地搜索"
            maxlength="64"></el-input>
          <el-input style="width: 150px; margin-left: 10px" v-model="lineForm.params.endStationName" placeholder="目的地搜索"
            maxlength="64"></el-input>
          <div style="display: inline-block; float: right">
            <el-button type="primary" @click="queryFn">查询</el-button>
            <el-button @click="resetFn">重置</el-button>
          </div>
        </div>
        <el-table style="margin: 20px 0; min-height: 300px" ref="tableLineSelection" border v-loading="loadingLine"
          :data="lineForm.table" :max-height="500" v-loadmore="listFnPush" @row-click="onRowClick" @select="onSelect"
          @select-all="onSelectAll">
          <el-table-column fixed="left" type="selection" width="45"></el-table-column>
          <el-table-column label="出发地">
            <template slot-scope="scope">
              <p>{{ scope.row.startStationName }}</p>
              <p style="color: #999">{{ scope.row.startProvincialCity }}</p>
            </template>
          </el-table-column>
          <el-table-column label="目的地">
            <template slot-scope="scope">
              <p>{{ scope.row.endStationName }}</p>
              <p style="color: #999">{{ scope.row.endProvincialCity }}</p>
            </template>
          </el-table-column>
        </el-table>
        <el-button type="primary" @click="lineSave"> 确定 </el-button>
      </div>
    </el-dialog>
    <el-form :model="form" :rules="rules" ref="form" label-width="100px">
      <el-form-item label="优惠券名称" prop="name">
        <el-input v-model="form.name" maxlength="14" placeholder="展示给用户看的名称"></el-input>
      </el-form-item>
      <el-form-item label="优惠券说明" prop="explanation">
        <el-input v-model="form.explanation" maxlength="20" placeholder="展示给用户看的说明"></el-input>
      </el-form-item>
      <el-form-item label="类型" prop="type">
        <el-radio-group v-model="form.type" style="width: 100%">
          <div class="radio-group-line">
            <el-radio :label="1"> 直减 </el-radio>
            <el-input v-model="form.couponFee" maxlength="3" placeholder="请输入直减金额" :disabled="form.type !== 1">
              <template slot="append">元</template>
            </el-input>
          </div>
          <div class="radio-group-line">
            <el-radio :label="2"> 折扣 </el-radio>
            <el-input maxlength="3" v-model="form.discount" placeholder="请输入折扣" :disabled="form.type !== 2">
              <template slot="append">折</template>
            </el-input>
          </div>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="有效期" prop="validityType">
        <el-radio-group v-model="form.validityType" style="width: 100%">
          <div class="radio-group-line">
            <el-radio :label="1"> 以自然日计算 </el-radio>
            <el-input v-model="form.naturalDay" maxlength="5" placeholder="请设置领取自然有效期"
              :disabled="form.validityType !== 1">
              <template slot="append">天</template>
            </el-input>
          </div>
          <div class="radio-group-line">
            <el-radio :label="2"> 以截止日计算 </el-radio>
            <!--日期时间-->
            <el-date-picker v-model="form.expirationDay" type="datetime" format="yyyy/MM/dd HH:mm" placeholder="请设置截至时间"
              value-format="timestamp" :disabled="form.validityType !== 2"></el-date-picker>
          </div>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="获取方式" prop="obtainMethod">
        <el-radio-group v-model="form.obtainMethod" style="width: 100%">
          <div class="radio-group-line">
            <el-radio :label="1"> 注册赠送 </el-radio>
            <el-input v-model="form.issuedNumRule1" maxlength="2" placeholder="给新注册用户赠送的优惠券"
              :disabled="form.obtainMethod !== 1">
              <template slot="append">张</template>
            </el-input>
          </div>
          <div class="radio-group-line">
            <el-radio :label="3"> 登录赠送(重复赠送) </el-radio>
            <el-input v-model="form.issuedNumRule3" maxlength="2" placeholder="同个用户每次登录都能获赠"
              :disabled="form.obtainMethod !== 3">
              <template slot="append">张 </template>
            </el-input>
          </div>
          <div class="radio-group-line">
            <el-radio :label="2"> 登录赠送(只限一次) </el-radio>
            <el-input v-model="form.issuedNumRule2" maxlength="2" placeholder="同个用户只能获得赠送一次"
              :disabled="form.obtainMethod !== 2">
              <template slot="append">张 </template>
            </el-input>
          </div>

          <div class="radio-group-line">
            <el-radio :label="4"> 分享有礼 </el-radio>
            <el-input v-model="form.issuedNumRule4" maxlength="2" placeholder="分享条件达成后分享者获赠一次"
              :disabled="form.obtainMethod !== 4">
              <template slot="append">张 </template>
            </el-input>
          </div>
          <div class="radio-group-line">
            <el-radio :label="5"> 活动赠送 </el-radio>
            <el-input disabled placeholder="绑定营销活动，用户参与活动赠送优惠券"></el-input>
          </div>
        </el-radio-group>
      </el-form-item>
      <el-form-item>
        <p class="util-remark">
          说明：分享有礼-将小程序分享给新用户，当新用户完成注册后首次购票并完单时，赠送给分享者n张优惠券。
        </p>
      </el-form-item>

      <el-form-item label="发放数量" prop="issuedNum">
        <el-input v-model="form.issuedNum" maxlength="8" placeholder="要发放的数量"></el-input>
      </el-form-item>
      <el-form-item label="使用条件" prop="limitFee">
        <div class="flex">
          <el-checkbox :checked="true" disabled>
            <div class="checkbox-group-line flex">
              <span>使用门槛金额</span>
              <div>
                <el-input v-model="form.limitFee" maxlength="6" placeholder="使用优惠券门槛金额" style="width: 331px;">
                  <template slot="append">元</template>
                </el-input>
              </div>
            </div>
          </el-checkbox>
        </div>

      </el-form-item>
      <el-form-item label="" prop="">
        <div class="flex">
          <el-checkbox v-model="form.checkbox2" @change="useAgeChange">
            <div class=" checkbox-group-line flex">
              <span>乘车人年龄限制</span>
            </div>
          </el-checkbox>
          <div class=" checkbox-group-line flex">
            <el-form-item prop="limitAgeMin" style="padding-top: 16px;">
                <el-input v-model="form.limitAgeMin" maxlength="3" placeholder="最小年龄" style="width: 156px;" :disabled="!form.checkbox2">
                  <template slot="append">岁</template>
                </el-input>
              </el-form-item>
              <span style="width: 20px; text-align: center;">至</span>
              <el-form-item prop="limitAgeMax"  style="padding-top: 16px;">
                <el-input v-model="form.limitAgeMax" maxlength="3" placeholder="最大年龄" style="width: 156px;" :disabled="!form.checkbox2">
                  <template slot="append">岁</template>
                </el-input>
              </el-form-item>
          </div>
        </div>

      </el-form-item>
      <el-form-item>
        <p class="util-remark">
          门槛金额：订单金额需达到门槛金额才可使用优惠券
        </p>
        <p class="util-remark">
          年龄限制：实名购票时乘车人年龄需符合要求才可使用优惠券
        </p>
      </el-form-item>

      <el-form-item label="机构名称" prop="organizationId">
        <el-select :disabled="mixinUserInfo.organizationType != 1" style="width: 100%;" v-model="form.organizationId"
          filterable>
          <el-option v-for="val in organizations" :key="val.id" :value="val.id" :label="val.name">
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="适用线路" prop="useLineType">
        <el-radio-group v-model="form.useLineType" style="width: 100%">
          <div class="radio-group-line">
            <el-radio :label="1">
              <strong style="margin-right: 20px"> 全部线路</strong>
              <span style="color: #606266"> 当前机构全部线路均可使用</span>
            </el-radio>
          </div>
          <div class="radio-group-line">
            <el-radio :label="2">
              <strong style="margin-right: 20px"> 部分线路</strong>
              <span style="color: #606266"> 指定线路才能使用</span>
            </el-radio>
          </div>
        </el-radio-group>
      </el-form-item>
      <el-table style="margin-bottom: 20px" border empty-text="暂无数据" :data="lineRows">
        <el-table-column label="出发地">
          <template slot-scope="scope">
            <p>{{ scope.row.startStationName }}</p>
            <p style="color: #999">{{ scope.row.startProvincialCity }}</p>
          </template>
        </el-table-column>
        <el-table-column label="目的地">
          <template slot-scope="scope">
            <p>{{ scope.row.endStationName }}</p>
            <p style="color: #999">{{ scope.row.endProvincialCity }}</p>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="80px;">
          <template slot-scope="{ $index }">
            <el-button type="text" @click="lineRows.splice($index, 1)" class="testlist">删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-button style="border: 1px #dcdfe6 dashed; padding: 10px; width: 100%" @click="lineAdd"
        :disabled="form.useLineType == 1">添加线路</el-button>
      <br /><br />

      <el-form-item style="padding: 20px 0 50px; text-align: right">
        <el-button type="primary" @click="saveClick" :loading="loading">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
export default {
  name: "couponForm",
  directives: {
    loadmore: {
      bind(el, binding) {
        const selectWrap = el.querySelector(".el-table__body-wrapper");
        selectWrap.addEventListener("scroll", function () {
          const sign = 1;
          const scrollDistance =
            this.scrollHeight - this.scrollTop - this.clientHeight;
          if (scrollDistance <= sign) {
            binding.value();
          }
        });
      },
    },
  },
  data() {
    let validateType = (rule, value, callback) => {
      let reg = /^[1-9]\d*?$/;
      let reg1 = /(^[1-9]{1}[0-9]*$)|(^[0-9]*\.[0-9]{1}$)/;
      if (value === 1) {
        if (!this.form.couponFee) {
          callback(new Error("请输入直减金额"));
        } else if (!reg.test(this.form.couponFee)) {
          callback(new Error("请输入正整数"));
        } else {
          callback();
        }
      } else {
        if (!this.form.discount) {
          callback(new Error("请输入折扣"));
        } else if (!reg1.test(this.form.discount)) {
          callback(new Error("请输入正确的折扣"));
        } else if (Number(this.form.discount) >= 10) {
          callback(new Error("请小于10"));
        } else if (Number(this.form.discount) <= 0) {
          callback(new Error("请输入正确的折扣"));
        } else {
          callback();
        }
      }
    };
    let issuedNumRule = (rule, value, callback) => {
      let reg = /^[1-9]\d*?$/;
      if (value === 1) {
        if (!this.form.issuedNumRule1) {
          callback(new Error("请输入新注册用户赠送优惠券数量"));
        } else if (!reg.test(this.form.issuedNumRule1)) {
          callback(new Error("请输入正整数"));
        } else {
          callback();
        }
      } else if (value === 3) {
        if (!this.form.issuedNumRule3) {
          callback(new Error("请输入用户每次登录赠送优惠券数量"));
        } else if (!reg.test(this.form.issuedNumRule3)) {
          callback(new Error("请输入正整数"));
        } else {
          callback();
        }
      } else if (value === 2) {
        if (!this.form.issuedNumRule2) {
          callback(new Error("请输入用户第一次登录赠送优惠券数量"));
        } else if (!reg.test(this.form.issuedNumRule2)) {
          callback(new Error("请输入正整数"));
        } else {
          callback();
        }
      } else if (value === 4) {
        if (!this.form.issuedNumRule4) {
          callback(new Error("请输入分享有礼赠送优惠券数量"));
        } else if (!reg.test(this.form.issuedNumRule4)) {
          callback(new Error("请输入正整数"));
        } else {
          callback();
        }
      } else if (value === 5) {
        // 活动赠送不需要验证数量
        callback();
      }
    };
    let validateValidityType = (rule, value, callback) => {
      let reg = /^[1-9]\d*?$/;
      if (value === 1) {
        if (!this.form.naturalDay) {
          callback(new Error("请设置领取自然有效期"));
        } else if (!reg.test(this.form.naturalDay)) {
          callback(new Error("请输入正确的数字"));
        } else {
          callback();
        }
      } else {
        if (!this.form.expirationDay) {
          callback(new Error("请设置截至时间"));
        } else if (this.form.expirationDay <= Date.now()) {
          callback(new Error("截至时间请大于当前时间!"));
        } else {
          callback();
        }
      }
    };
    let validateLimitFee = (rule, value, callback) => {
      if (this.form.type === 1 && this.form.couponFee) {
        if (Number(value) < Number(this.form.couponFee)) {
          callback(new Error("请大于等于直减金额"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    };
    let validateUseLineType = (rule, value, callback) => {
      if (value) {
        if (this.lineRows.length == 0 && value == 2) {
          callback(new Error("请添加适用线路"));
        } else {
          callback();
        }
      } else {
        callback(new Error("请选择适用线路"));
      }
    };
    let validateAgeMin = (rule, value, callback) => {
      if (this.form.checkbox2) {
        if (value) {
          let reg = /^[1-9]\d*?$/;
          if (!reg.test(this.form.limitAgeMin)) {
            callback(new Error("请输入正整数"));
          }else if (+value > 100) {
            callback(new Error("请输入小于等于100的年龄"));
          } else if (this.form.limitAgeMax && +this.form.limitAgeMax < +value) {
            callback(new Error("请小于最大年龄"));
          }else {
            callback();
          }
        } else {
          callback(new Error("请输入最小年龄"));
        }
      } else {
        callback();
      }
    };
    let validateAgeMax = (rule, value, callback) => {
      if (this.form.checkbox2) {
        if (value) {
          let reg = /^[1-9]\d*?$/;
          if (!reg.test(this.form.limitAgeMax)) {
            callback(new Error("请输入正整数"));
          }else if (+value > 100) {
            callback(new Error("请输入小于等于100的年龄"));
          } else if (this.form.limitAgeMin && +this.form.limitAgeMin > +value) {
            callback(new Error("请大于最小年龄"));
          }else {
            callback();
          }
        } else {
          callback(new Error("请输入最大年龄"));
        }
      } else {
        callback();
      }
    };

    return {
      // 司机id
      id: this.$route.query.id,
      // 表单
      form: {
        organizationId: null,
        type: 1,
        validityType: 1,
        obtainMethod: 1,
        limitAgeMin: null,
        limitAgeMax: null
      },
      // 校验规则
      rules: {
        name: [{ required: true, message: "请输入名称" }],
        explanation: [{ required: true, message: "请输入说明" }],
        type: [
          { required: true, message: "请选择类型" },
          { validator: validateType },
        ],
        obtainMethod: [
          { required: true, message: "请选择获取方式" },
          { validator: issuedNumRule },
        ],
        validityType: [
          { required: true, message: "请选择有效期" },
          { validator: validateValidityType },
        ],
        issuedNum: [
          { required: true, message: "请输入要发放的数量" },
          { pattern: /^[1-9]\d*?$/, message: "请输入正确的数字" },
        ],
        limitFee: [
          { required: true, message: "请输入金额" },
          {
            pattern: /(^[1-9]{1}[0-9]*$)|(^[0-9]*\.[0-9]{1}$)/,
            message: "请输入正确的金额",
          },
          { validator: validateLimitFee },
        ],
        organizationId: [{ required: true, message: "请选择机构" }],
        useLineType: [
          {
            required: true,
            validator: validateUseLineType,
          },
        ],
        limitAgeMin: [
          {
            validator: validateAgeMin,
          },
        ],
        limitAgeMax: [
          {
            validator: validateAgeMax,
          },
        ],
      },
      // 保存按钮loading
      loading: false,

      // 部分线路信息
      lineRows: [],

      // 选中部分线路信息
      lineVisible: false,
      lineForm: {
        table: [],
        params: {
          organizationName: "",
          page: 0,
          size: 20,
          startStationName: null,
          endStationName: null,
        },
        total: 20,
      },
      selectionLineList: [],
    };
  },
  watch: {
    "form.organizationId"(val) {
      this.organizations.map((item) => {
        if (item.id == val) {
          this.lineForm.params.organizationName = item.name;
        }
      });
      this.lineForm.params.organizationId = val;
      this.lineRows = [];
      this.selectionLineList = [];
      this.queryFn();
    },
    "form.useLineType"(val) {
      if (val == 1) {
        this.lineRows = [];
      }
    },
  },
  methods: {
    useAgeChange(value) {
      console.log(value)
      if(!value) {
        this.form.limitAgeMin = null
        this.form.limitAgeMax = null
      }
    },
    // 添加线路
    lineAdd() {
      this.lineVisible = true;
      this.selectionLineList = JSON.parse(JSON.stringify(this.lineRows));
      // 默认勾选上一页的选中复选框
      this.$nextTick(() => {
        if (this.lineRows.length > 0) {
          this.lineForm.table.forEach((row) => {
            row.checkStatus = false;
            this.$refs.tableLineSelection.toggleRowSelection(row, false);
            this.lineRows.map((item) => {
              if (item.id == row.id) {
                row.checkStatus = true;
                this.$refs.tableLineSelection.toggleRowSelection(row, true);
              }
            });
          });
        } else {
          this.lineForm.table.forEach((row) => {
            row.checkStatus = false;
          });
          this.$refs.tableLineSelection.clearSelection();
        }
      });
    },
    // 查询
    queryFn() {
      if (!this.loadingLine) {
        this.lineForm.params.page = 0;
        this.lineForm.total = 20;
        this.lineForm.table = [];
        this.listFnPush();
      }
    },
    // 重置
    resetFn() {
      if (!this.loadingLine) {
        this.lineForm.params.startStationName = null;
        this.lineForm.params.endStationName = null;
        this.lineForm.params.page = 0;
        this.lineForm.total = 20;
        this.lineForm.table = [];
        this.listFnPush();
      }
    },
    /**
     * 接口调用-滚动分页获取列表信息
     */
    async listFnPush() {
      if (
        this.lineForm.total <=
        this.lineForm.params.page * this.lineForm.params.size
      ) {
        return;
      }

      let selectionLineList = this.selectionLineList;
      this.loadingLine = true;
      this.lineForm.params.page = this.lineForm.params.page + 1;
      let url = "/api/v1/manage/line/recommend/line";
      let data = await this.$axios.get(url, this.lineForm.params);

      if (data && data.code == 1) {
        this.lineForm.table = this.lineForm.table.concat(data.data) || [];
        this.lineForm.total = data.total || 0;
      } else {
        this.table = [];
        this.lineForm.total = 20;
      }
      this.loadingLine = false;

      // 默认勾选上一次的选中复选框
      this.$nextTick(() => {
        if (selectionLineList.length > 0) {
          this.lineForm.table.forEach((row) => {
            row.checkStatus = false;
            this.selectionLineList.forEach((item) => {
              if (item.id == row.id) {
                row.checkStatus = true;
                this.$refs.tableLineSelection.toggleRowSelection(row, true);
              }
            });
          });
        }
      });
    },
    /**
     * 当某一行被点击时会触发该事件
     */
    onRowClick(row) {
      let index = this.lineForm.table.findIndex((item) => {
        return item.id == row.id;
      });
      if (this.lineForm.table[index].checkStatus) {
        let i = this.selectionLineList.findIndex((item) => {
          return item.id == this.lineForm.table[index].id;
        });
        this.selectionLineList.splice(i, 1);
        this.lineForm.table[index].checkStatus = false;
      } else {
        let push = true;
        this.selectionLineList.map((item) => {
          if (item.id == this.lineForm.table[index].id) {
            push = false;
          }
        });
        if (push) {
          this.selectionLineList.push(this.lineForm.table[index]);
        }
        this.lineForm.table[index].checkStatus = true;
      }
      this.$refs.tableLineSelection.toggleRowSelection(
        this.lineForm.table[index]
      );
    },
    // 复选框格子选择事件
    onSelect(selection, row) {
      let index = this.lineForm.table.findIndex((item) => {
        return item.id == row.id;
      });
      if (this.lineForm.table[index].checkStatus) {
        let i = this.selectionLineList.findIndex((item) => {
          return item.id == this.lineForm.table[index].id;
        });
        this.selectionLineList.splice(i, 1);
        this.lineForm.table[index].checkStatus = false;
      } else {
        let push = true;
        this.selectionLineList.map((item) => {
          if (item.id == this.lineForm.table[index].id) {
            push = false;
          }
        });
        if (push) {
          this.selectionLineList.push(this.lineForm.table[index]);
        }
        this.lineForm.table[index].checkStatus = true;
      }
    },
    // 全选事件
    onSelectAll(selection) {
      if (selection.length == 0) {
        this.lineForm.table.forEach((row) => {
          row.checkStatus = false;
        });
        this.selectionLineList.length = 0;
      } else {
        this.lineForm.table.forEach((row) => {
          row.checkStatus = true;
          let push = true;
          this.selectionLineList.map((item) => {
            if (row.id == item.id) {
              push = false;
            }
          });
          if (push) {
            this.selectionLineList.push(row);
          }
        });
      }
    },
    // 线路保存
    lineSave() {
      this.lineRows = this.selectionLineList;
      this.$refs.form.validateField("useLineType");
      this.lineVisible = false;
    },

    /**
     * 保存
     */
    saveClick() {
      console.log('this.form',this.form)
      this.$refs.form.validate((valid) => {
        console.log('valid',valid)
        if (valid) {
          if (this.form.issuedNumRule1 && this.form.obtainMethod == 1) {
            this.form.issuedNumRule = this.form.issuedNumRule1;
          } else if (this.form.issuedNumRule2 && this.form.obtainMethod == 2) {
            this.form.issuedNumRule = this.form.issuedNumRule2;
          } else if (this.form.issuedNumRule3 && this.form.obtainMethod == 3) {
            this.form.issuedNumRule = this.form.issuedNumRule3;
          } else if (this.form.issuedNumRule4 && this.form.obtainMethod == 4) {
            this.form.issuedNumRule = this.form.issuedNumRule4;
          }else if (this.form.obtainMethod == 5) {
            this.form.issuedNumRule = 1;
          }
          if (this.form.useLineType == 2 && this.lineRows) {
            let useLineIds = this.lineRows.map((item) => {
              return item.id;
            });
            this.form.useLineIds = useLineIds.join(",");
          }
          if (this.id) {
            this.putFn(this.form);
          } else {
            this.postFn(this.form);
          }
        } else {
          this.$message.warning("请检查表单数据是否输入正确！");
          return false;
        }
      });
    },
    /**
     * 接口请求-新增
     * @return {Promise<void>}
     */
    async postFn(form) {
      this.loading = true;
      try {
        let url = "/api/v1/manage/coupon";
        let params = this.$utils.deepCopyFn(form);
        params.expirationDay = params.expirationDay
          ? params.expirationDay / 1000
          : "";
        let data = await this.$axios.post(url, params);
        if (data && data.code === 1) {
          this.$message.success("保存成功！");
          this.$router.go(-1);
        }
      } finally {
        this.loading = false;
      }
    },
    /**
     * 接口请求-编辑
     * @return {Promise<void>}
     */
    async putFn(form) {
      this.loading = true;
      try {
        let url = "/api/v1/manage/coupon";
        let params = this.$utils.deepCopyFn(form);
        params.expirationDay = params.expirationDay
          ? params.expirationDay / 1000
          : "";
        let data = await this.$axios.put(url, params);
        if (data && data.code === 1) {
          this.$message.success("保存成功！");
          this.$router.go(-1);
        }
      } finally {
        this.loading = false;
      }
    },
    /**
     * 接口请求-单个详情
     */
    async getInfo() {
      if (!this.id) {
        return false;
      }
      let url = "/api/v1/manage/coupon/" + this.id;
      let data = await this.$axios.get(url);
      if (data && data.code === 1) {
        data.data.expirationDay = data.data.expirationDay
          ? data.data.expirationDay * 1000
          : "";
        this.form = data.data || {};
      }
    },
  },
  async created() {
    this.getInfo();
    this.listFnPush();
    await this.mixinOrganizations();
    this.form.organizationId = this.organizations[0].id;
    this.lineForm.params.organizationName = this.organizations[0].name;
  },
};
</script>

<style lang="less">
#couponForm {
  width: 575px;

  .el-radio {
    width: 200px;
  }

  .radio-group-line {
    display: flex;
    line-height: 28px;
    align-items: center;
  }

  .radio-group-line+.radio-group-line {
    padding-top: 10px;
  }

  .radio-group-line {
    .util-remark {
      padding-left: 16px;

      span {
        color: #333;
        padding-right: 16px;
      }
    }
  }

  .flex {
    display: flex;
    align-content: center;
  }

  .checkbox-group-line {
    span {
      width: 120px;
    }
  }

  .el-form {
    .el-form-item {
      .el-form-item__label {
        text-align: left;
      }
    }
  }
}
</style>
